import { Popover } from 'antd';
import CircularProgressBar from '../../../../components/CircularProgressBar';
import { truncate } from 'lodash';
import React from 'react';
import style from '../index.scss';
import moment from 'moment';
import { dateTimeFormat } from '../../../../util/GlobalConstant';

import SingleHeader from './SingleHeader';
import MultiHeader from './MultiHeader';
import SingleDataColumn from './SingleDataColumn';
import MultiDataColumn from './MultiDataColumn';

export { MultiHeader, SingleHeader, SingleDataColumn, MultiDataColumn };

/**
 * SingleRowComponent
 * @param details
 * @param expectedCloseDate
 * @param rowOne
 * @returns {JSX.Element}
 * @constructor
 */
export const SingleRowComponent = ({ details, expectedCloseDate, rowOne }) => {
  const updatedDetails = { ...expectedCloseDate, ...details };
  const dataRowOne = updatedDetails[rowOne] ? updatedDetails[rowOne] : '-';

  if (rowOne === 'feedback') {
    let style = {
      backgroundColor: 'lightgray',
      padding: '1px 8px',
      width: 80,
      height: 'auto',
      borderRadius: 4,
      fontSize: 11,
      textTransform: 'uppercase',
      textAlign: 'center'
    };
    if (dataRowOne === 'rejected') {
      style = { ...style, backgroundColor: '#DF6057' };
    }
    if (dataRowOne === 'relevant') {
      style = { ...style, backgroundColor: '#71C969' };
    }
    return (
      <div style={style}>{dataRowOne ? dataRowOne : 'Not yet resolved'}</div>
    );
  }

  if (rowOne === 'alertScore') {
    return (
      <Popover
        content={
          <div
            style={{
              fontSize: 11,
              padding: 5,
              color: '#31394D',
              fontWeight: 500
            }}>
            {dataRowOne}
          </div>
        }>
        <CircularProgressBar
          key={dataRowOne}
          percentage={Number(dataRowOne).toFixed(2)}
          strokeFill={'#BC24DA'}
        />
      </Popover>
    );
  }

  return (
    <Popover
      content={
        <div
          style={{
            fontSize: 11,
            padding: 5,
            color: '#31394D',
            fontWeight: 500
          }}>
          {dataRowOne}
        </div>
      }>
      <div
        style={{
          fontSize: 11,
          padding: 5,
          color: '#31394D',
          fontWeight: 500
        }}>
        {truncate(dataRowOne, { length: 30 })}
      </div>
    </Popover>
  );
};

/**
 * DualRowComponent
 * @param details
 * @param expectedCloseDate
 * @param rowOne
 * @param rowTwo
 * @returns {JSX.Element}
 * @constructor
 */
export const DualRowComponent = ({
  details,
  expectedCloseDate,
  rowOne,
  rowTwo
}) => {
  const updatedDetails = { ...expectedCloseDate, ...details };
  let dataRowOne = updatedDetails[rowOne] ? updatedDetails[rowOne] : '-';
  let dataRowTwo = updatedDetails[rowTwo] ? updatedDetails[rowTwo] : '-';

  if (rowTwo === 'alertDate') {
    dataRowTwo = moment.utc(dataRowTwo, [dateTimeFormat]).format('DD/MM/YYYY');
  }

  if (rowTwo === 'alertId' || rowOne === 'alertId') {
    return (
      <Popover
        content={
          <div style={{ display: 'flex', flexDirection: 'column' }}>
            <div
              style={{
                fontSize: 11,
                padding: 5,
                color: '#31394D',
                fontWeight: 500
              }}>
              {dataRowOne}
            </div>
            <div
              style={{
                fontSize: 11,
                padding: 5,
                color: '#748AA1',
                fontWeight: 'normal'
              }}>
              {dataRowTwo}
            </div>
          </div>
        }>
        <div style={{ padding: 5, display: 'flex', flexDirection: 'column' }}>
          <div
            style={{
              fontSize: 11,
              padding: 5,
              color: '#0C8ED7',
              fontWeight: 500
            }}>
            {truncate(dataRowOne, { length: 30 })}
          </div>
          <div
            style={{
              fontSize: 11,
              padding: 5,
              color: '#748AA1',
              fontWeight: 'normal'
            }}>
            {truncate(dataRowTwo, { length: 30 })}
          </div>
        </div>
      </Popover>
    );
  }

  if (rowOne === 'typologies') {
    try {
      dataRowOne = JSON.parse(dataRowOne);
      if (Array.isArray(dataRowOne) && dataRowOne.length > 0) {
        let typology_name = '';
        let typology_ids = '';
        dataRowOne.forEach((typologyObject) => {
          const { typologyName, id } = typologyObject;
          typology_name += typologyName + ', ';
          typology_ids += String(id) + ', ';
        });
        dataRowOne = typology_name;
        dataRowTwo = typology_ids;
      }
    } catch (error) {
      dataRowOne = '-';
      dataRowTwo = '-';
    }
  }

  return (
    <Popover
      content={
        <div style={{ display: 'flex', flexDirection: 'column' }}>
          <div
            style={{
              fontSize: 11,
              padding: 5,
              color: '#31394D',
              fontWeight: 500
            }}>
            {dataRowOne}
          </div>
          <div
            style={{
              fontSize: 11,
              padding: 5,
              color: '#748AA1',
              fontWeight: 'normal'
            }}>
            {dataRowTwo}
          </div>
        </div>
      }>
      <div style={{ padding: 5, display: 'flex', flexDirection: 'column' }}>
        <div
          style={{
            fontSize: 11,
            padding: 5,
            color: '#31394D',
            fontWeight: 500
          }}>
          {truncate(dataRowOne, { length: 30 })}
        </div>
        <div
          style={{
            fontSize: 11,
            padding: 5,
            color: '#748AA1',
            fontWeight: 'normal'
          }}>
          {truncate(dataRowTwo, { length: 30 })}
        </div>
      </div>
    </Popover>
  );
};

/**
 * TriRowComponent Component
 * @param details
 * @param expectedCloseDate
 * @param rowOne
 * @param rowTwo
 * @param rowThree
 * @returns {JSX.Element}
 * @constructor
 */
export const TriRowComponent = ({
  details,
  expectedCloseDate,
  rowOne,
  rowTwo,
  rowThree
}) => {
  const updatedDetails = { ...expectedCloseDate, ...details };
  const dataRowOne = updatedDetails[rowOne] ? updatedDetails[rowOne] : '-';
  let dataRowTwo = updatedDetails[rowTwo] ? updatedDetails[rowTwo] : '-';
  const dataRowThree = updatedDetails[rowThree]
    ? updatedDetails[rowThree]
    : '-';

  if (rowTwo === 'expectedCloseDate' && dataRowTwo !== '-') {
    dataRowTwo = moment.utc(dataRowTwo, [dateTimeFormat]).format('DD/MM/YYYY');
  }

  return (
    <div style={{ fontSize: 11, display: 'flex', flexDirection: 'column' }}>
      <div
        style={{
          fontSize: 11,
          padding: 5,
          color: '#31394D',
          fontWeight: 500
        }}>
        {dataRowOne}
      </div>
      <div
        style={{
          fontSize: 11,
          padding: 5,
          color: '#31394D',
          fontWeight: 'normal'
        }}>
        {dataRowTwo}
      </div>
      <div
        style={{
          fontSize: 11,
          padding: 5,
          color: '#31394D',
          fontWeight: 'normal'
        }}>
        {dataRowThree}
      </div>
    </div>
  );
};

/**
 * DualHeaderComponent
 * @param props
 * @returns {JSX.Element}
 * @constructor
 */
export const DualHeaderComponent = (props) => {
  const { header1, header2 } = props;
  return (
    <div className={style.dualHeader}>
      <div>{header1}</div>
      {header2 ? <div>{header2}</div> : <div>&nbsp;&nbsp;&nbsp;</div>}
    </div>
  );
};

/**
 * TriHeaderComponent
 * @param props
 * @returns {JSX.Element}
 * @constructor
 */
export const TriHeaderComponent = (props) => {
  const { header1, header2, header3 } = props;
  return (
    <div className={style.dualHeader}>
      <div>{header1}</div>
      <div>{header2}</div>
      <div>{header3}</div>
    </div>
  );
};
